import { Just, Nothing } from 'core/maybe';
import { unreachable } from 'utils/unreachable';
export const Empty = ()=>[
        'empty'
    ];
export const Loading = ()=>[
        'loading'
    ];
export const Loaded = (result)=>[
        'loaded',
        result
    ];
export const Refreshing = ([, current])=>[
        'refreshing',
        current
    ];
export const Creating = (value)=>[
        'creating',
        value
    ];
export const Updating = (next, previous)=>[
        'updating',
        next,
        previous
    ];
export const Deleting = (previous)=>[
        'deleting',
        previous
    ];
export const Content = {
    isEmpty: (value)=>value[0] === 'empty',
    isLoading: (value)=>value[0] === 'loading',
    of: (value)=>Loaded(value),
    ofNullable: (value)=>value == null ? Empty() : Loaded(value),
    map: (mapper)=>(content)=>{
            switch(content[0]){
                case 'empty':
                    return Empty();
                case 'loading':
                    return Loading();
                case 'loaded':
                    return Loaded(mapper(content[1]));
                default:
                    return unreachable(content);
            }
        },
    flatten: (content)=>{
        switch(content[0]){
            case 'empty':
                return Empty();
            case 'loading':
                return Loading();
            case 'loaded':
                switch(content[1][0]){
                    case 'empty':
                        return Empty();
                    case 'loading':
                        return Loading();
                    case 'loaded':
                        return Loaded(content[1][1]);
                    default:
                        return unreachable(content[1]);
                }
            default:
                return unreachable(content[0]);
        }
    },
    orElse: (otherwise)=>(content)=>(content === null || content === void 0 ? void 0 : content[0]) === 'loaded' ? content[1] : otherwise
};
export const RefreshableContent = {
    map: (mapper)=>(content)=>{
            switch(content[0]){
                case 'refreshing':
                    return Refreshing(Loaded(mapper(content[1])));
                default:
                    return Content.map(mapper)(content);
            }
        },
    hasData: ([status])=>status === 'loaded' || status === 'refreshing',
    toMaybe: (content)=>{
        switch(content[0]){
            case 'refreshing':
            case 'loaded':
                return Just(content[1]);
            default:
                return Nothing();
        }
    }
};
